export const DistributionChannel = {
    SOCIAL: 'Social',
    DIGITAL_MEDIA: 'Digital Media',
    WEBSITE: 'Website',
    ECOMMERCE: 'Ecommerce',
    TELEVISION: 'TV',
    PACKAGING: 'Packaging',
    EMAIL: 'Email',
    UNKNOWN: 'Other'
};



// WEBPACK FOOTER //
// ./common/language/content_component/distribution_channel.js